const metric = {
  radius: "8px",
  margin20: "20px",
  heightNavigationBottom: "65px",
};
export default metric;
